import '@fontsource/barlow/400.css'
import '@fontsource/barlow/500.css'
import '@fontsource/barlow/600.css'
import '@fontsource/barlow/700.css'

import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'

import { setSessionExpiredHandler } from '@/api/client'
import { ToasterProvider } from '@/components/feedback/Toaster'
import { MotionProvider } from '@/motion/MotionProvider'
import { router } from '@/router'
import { theme } from '@/theme/theme'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // O portal fala com uma API que muda por fora (Postman, operação da
      // PO27), então revalidar ao voltar para a aba é o comportamento certo.
      refetchOnWindowFocus: true,
      retry: false,
      staleTime: 10_000,
    },
  },
})

// Qualquer 401 fora do login derruba o cache e leva para a tela de entrada.
setSessionExpiredHandler(() => {
  queryClient.clear()
  void router.navigate('/login?expired=1', { replace: true })
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider theme={theme} defaultMode="dark" modeStorageKey="tp.colorMode">
      <CssBaseline enableColorScheme />
      <MotionProvider>
        <QueryClientProvider client={queryClient}>
          <ToasterProvider>
            <RouterProvider router={router} />
          </ToasterProvider>
        </QueryClientProvider>
      </MotionProvider>
    </ThemeProvider>
  </StrictMode>,
)
